import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form';
import Errors from './Errors'

import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  is_validating,
  is_manager
} from "../helpers"

import {
  create_user_init,
  create_user,
  reset_user_errors,
  accounts_autocomplete
} from '../actions'

const {FormSelect, Autocomplete} = window.M

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    errors: state.user.errors,
    account_names: state.account.account_names,
    account_data: state.account.account_data,
    query: state.account.query,
    must_redirect: state.user.must_redirect
  };
}

const mapDispatchToProps = dispatch => {
  return {
    createUser: values => dispatch( create_user(values) ),
    initState: () => dispatch( create_user_init() ),
    resetErrors: () => dispatch ( reset_user_errors() ),
    getAutocompleteOptions: (query) => dispatch( accounts_autocomplete(query) )
  };
}

class ConnectedNewUser extends React.Component {
  constructor() {
    super()
    this.state = {
      autocomplete: null,
      roleSelect: null,
      redirect: false,
      searchValue: ''
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

	handleSubmit(values) {
    console.log(values)

    const { name, email, role, password, password_confirmation } = values
    const { current_user } = this.props

    let newRole
    if ( current_user.role === "manager" && role === "admin" ) {
      newRole = "user"
    } else {
      newRole = role
    }

    let account_id
    if ( current_user.role === "admin") {
      const { account_name } = values
      const { account_data } = this.props
      account_id = account_data[account_name]

    } else {
      account_id = current_user.account.id
    }

    let newValues = {
      name: name,
      email: email,
      role: newRole,
      password: password,
      password_confirmation: password_confirmation,
      account_id: account_id
    }

    this.props.createUser(newValues)

	}

  cancel() {
    this.setState({redirect: true})
  }

  changeOptions(e) {
    const newValue = e.target.value
    if ( newValue === null) {
      return
    }
    const value = newValue.trim()
    const { searchValue } = this.state
    const { account_names } = this.props
    const total_accounts = Object.keys(account_names).length
    if ( searchValue === '' || (value.includes(searchValue) && total_accounts === 20) || (!value.includes(searchValue)) ) {
      this.props.getAutocompleteOptions(value)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {account_names, query} = this.props
    const previousQuery = prevProps.query

    if ( previousQuery !== query ) {
      const {autocomplete} = this.state
      return autocomplete.updateData(account_names)
    }
  }

  componentDidMount() {
    const {current_user} = this.props

    const {formDispatch} = this
    const el1 = document.getElementById("therole")
    const roleSelect = FormSelect.init(el1)

    if (current_user.role === "admin") {
      const el2 = document.getElementById("account_name")
      const autocomplete = Autocomplete.init(el2, {
        data: {},
        limit: 5,
        onAutocomplete: function(value) {
          formDispatch(actions.change('localUser.account_name', value))
        }
      })
      this.setState({
        autocomplete: autocomplete,
        roleSelect: roleSelect
      })
    } else {
      this.setState({
        roleSelect: roleSelect
      })
    }
  }

  componentWillUnmount() {
    this.props.initState()
  }

	render() {
    const { current_user } = this.props

    if ( ( !is_validating() && !is_logged_on() ) || !is_manager() ) {
      return <Redirect to="/" />
    }

    if ( this.props.must_redirect || this.state.redirect ) {
      return <Redirect to="/users" />
    }

    const adminOption = (current_user.role === "admin") ? <option value="admin">Administrator</option> : ''

    let initState = {
      name: "",
      email: "",
      role: "user",
      password: "",
      password_confirmation: "",
    }
    if ( current_user.role === "admin" ) {
      initState = {
        ...initState,
        account_name: ""
      }
    }

		return (
			<div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Add New User</span>
					<i className="material-icons right">person_add</i>
				</div>

        <LocalForm
        className="collection-item"
        model="localUser"
        getDispatch={(dispatch) => this.attachDispatch(dispatch)}
        onSubmit = { (values) => {
          this.handleSubmit(values)
        }}
        initialState={initState}
        >

					<div className="section">
						<div className="input-field">
							<label htmlFor="thename" >{`What is the new user's name?`}</label>
							<Control.text id="thename" model= ".name" />
						</div>
					</div>

					<div className="section">
						<div className="input-field">
							<label htmlFor="themail">{`User's email. It will be used for login.`}</label>
							<Control.text type="email" id="themail" model=".email" />
						</div>
					</div>

          { current_user.role === "admin" && (
            <div className="section">
              <div className="input-field">
                <label htmlFor="account_name">{`User's Account... (autocomplete)`}</label>
                <Control.text id="account_name" model=".account_name" onChange={e=>{
                  this.changeOptions(e)
                }}/>
              </div>
            </div>
          )}

          <div className="section">
            <div className="input-field">
              <label htmlFor="therole" className="active">Role</label>
              <Control.select id="therole" className="roleSelect" model=".role" onChange={(e) => {
                e.preventDefault()
              }}>
                <option value="user">User</option>
                <option value="manager">Manager</option>
                { adminOption }
              </Control.select>
            </div>
					</div>

          <div className="section">
            <div className="input-field">
              <label htmlFor="password">{`User's Password`}</label>
              <Control.text type="text" id="password" model=".password" className="actuallyPassword"/>
            </div>
          </div>

          <div className="section">
            <div className="input-field">
              <label htmlFor="password_confirmation">Password Confirmation</label>
              <Control.text type="text" id="password_confirmation" model=".password_confirmation" className="actuallyPassword"/>
            </div>
          </div>

					<div className="section">
            <a href="" className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
              e.preventDefault()
              this.cancel()
            }}>Cancel</a>
						<button type="submit" className="btn red darken-1 waves-effect waves-light">Create User <i className="material-icons right">navigate_next</i></button>
					</div>
          <Errors errors={this.props.errors}/>
				</LocalForm>

			</div>
		)
	}
}

const NewUser = connect(mapStateToProps, mapDispatchToProps)(ConnectedNewUser);

export default NewUser;



// WEBPACK FOOTER //
// ./src/js/components/UserNew.js